/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-container[_ngcontent-%COMP%]{padding:5px;border:1px solid #fff;width:100%;background-color:#dcdcdc;color:#000}.button-container[_ngcontent-%COMP%]:hover{background-color:#fff;cursor:pointer}"];
export { styles as styles };
